<template>
  <div class="">
    <page-header light dark-crumb title="Политика использования Cookie" />
    <content-wrapper-block>
      <div class="cookie-policy">
        <div class="cookie-policy-text">
          <p>
            АО «ГК ОСНОВА» (далее — Оператор) обрабатывает данные, указанные в
            настоящем документе (далее — Политика), собранные в процессе
            использования Пользователями текущего Сайта. При нажатии кнопки
            «Принять» в окне-уведомлении об обработке Cookie, Вы даете свое
            согласие на обработку Ваших Cookie. Вы также можете отказаться от
            обработки Cookie в соответствии с пунктом 5 настоящей Политики.
          </p>
          <p>
            <b>1. Что такое файлы Cookie?</b><br />
            <b>Файлы cookie</b> — это небольшой фрагмент данных, который Сайт
            запрашивает у браузера, используемого на Вашем компьютере или
            мобильном устройстве. Файлы cookie содержат информацию о Ваших
            действиях на Сайте, а также могут содержать сведения об
            оборудовании, дату и время сессии.<br />
            <b>Сайт</b> — это совокупность текстов, графических элементов,
            дизайна, изображений, программного кода, и иных результатов
            интеллектуальной деятельности, содержащихся в
            информационно-телекоммуникационной сети «Интернет» под доменным
            именем «zk-mainstreet.ru», а также его поддоменов.<br />
            <b>Пользователь</b> – физическое лицо, намеревающееся принять
            Политику использования Cookies или принявшее его, а также
            использующее Сайт посредством информационно-телекоммуникационной
            сети Интернет.
          </p>

          <p>
            <b>2. Как мы используем Ваши Cookie?</b><br />
            Файлы cookie используются Оператором в целях улучшения и обеспечения
            нормальной работоспособности Сайта, а также в целях
            совершенствования продуктов и услуг, предоставляемых Оператором.
          </p>

          <p>
            <b>3. Какие виды Cookie мы используем?</b><br />
            <b>Сессионные.</b> Существуют только во временной памяти в течение
            времени, когда пользователь находится на странице Сайта. Браузеры
            обычно удаляют сессионные файлы cookie после того, как пользователь
            закрывает окно Сайта. Сессионные файлы cookis позволяют Сайту
            помнить информацию о выборе пользователя на предыдущей странице
            Сайта, чтобы избежать необходимости повторного ввода информации.<br />
            <b>Постоянные.</b>
            Файлы cookie, которые хранятся на Вашем устройстве и не удаляются
            при закрытии браузера. Постоянные файлы cookie могут сохранять
            пользовательские настройки для Сайта, позволяя использовать эти
            предпочтения в будущих сеансах использования Сайта. Такие файлы
            cookie позволяют идентифицировать Вас как уникального пользователя
            Сайта, и при возвращении на Сайт помогают вспомнить информацию о Вас
            и ранее совершенных Вами действиях.<br />
            <b>Обязательные.</b> Минимальный набор файлов cookie, использование
            которых необходимо для обеспечения правильной и бесперебойной работы
            Сайта.<br />
            <b>Аналитические / маркетинговые.</b> Эти файлы cookie помогают
            понять, как Вы взаимодействуете с Сайтом, предоставляя информацию о
            тех страницах, которые Вы посетили и количестве времени, которое Вы
            провели на Сайте. Так же эти файлы используются для улучшения
            функционала Сайта. Файлы cookie, относящиеся к аналитике, помогают
            измерять эффективность рекламных кампаний и оптимизировать
            содержание Сайтов для тех, кого заинтересовала реклама владельца
            Сайта или его партнеров.
          </p>

          <p>
            <b>4. Как мы обрабатываем Ваши Cookie?</b><br />
            На Сайте происходит сбор и обработка обезличенных данных с
            использованием метрических программ и систем аналитики, таких как
            «Яндекс.Метрика». Эта услуга предоставляется компанией ООО «ЯНДЕКС»
            (ИНН 7736207543). Дополнительную информацию о сервисе
            «Яндекс.Метрика» и политике конфиденциальности ООО «ЯНДЕКС» можно
            найти по адресу:
            <a href="https://yandex.ru/legal/confidential/" target="_blank"
              >https://yandex.ru/legal/confidential/</a
            >
            и
            <a
              href="https://yandex.ru/legal/metrica_termsofuse/"
              target="_blank"
              >https://yandex.ru/legal/metrica_termsofuse/</a
            >.
          </p>

          <p>
            <b>5. Управление файлами Cookie</b><br />
            Вы в любой момент можете принять решение об отказе предоставления и
            использования файлов cookie или удалить уже сохраненные cookie в
            настройках Вашего браузера. При этом Вы можете просматривать текст
            на Сайте, однако возможности индивидуальной настройки отображения,
            некоторые функции, сервисы, инструменты и возможности Сайта могут
            быть недоступны.<br />
            Если Вы решили отказаться от обработки файлов cookie, то Сайт будет
            использовать только обязательные cookie, необходимые для
            функционирования Сайта.
          </p>

          <p>
            <b>6. Как с нами связаться?</b><br />
            Настоящая Политика размещена на Сайте по адресу:
            https://zk-mainstreet.ru/cookie-policy и действует бессрочно до ее
            замены новой Политикой. В случае возникновения вопросов, связанных с
            обработкой Ваших персональных данных или реализации Ваших прав как
            субъекта персональных данных, пожалуйста, свяжитесь с нами,
            используя один из способов, указанных на странице
            <router-link slot="link" :to="{ name: 'ContactPage' }"
              >«Контакты»</router-link
            >.
          </p>
        </div>
      </div>
    </content-wrapper-block>
  </div>
</template>

<script>
import ContentWrapperBlock from "@/components/blocks/ContentWrapperBlock";
import PageHeader from "@/components/elements/PageHeader";

export default {
  name: "CookiePolicyPage",
  components: {
    PageHeader,
    ContentWrapperBlock,
  },
};
</script>

<style lang="scss" scoped>
.cookie-policy-text {
  font-family: $font-family-rubik;
  font-size: 13px;
  p {
    font-family: Rubik;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 170%;
    letter-spacing: 0.03em;
    color: #18181b;
    margin: 16px 0;
  }
  a {
    all: unset;
    text-decoration: underline;
    cursor: pointer;
  }
  .breakable-link {
    word-break: break-all;
  }
}
.page-header {
  padding-bottom: 0;
}
</style>
